<div class="card">
  <div class="">
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Correction Application List
    </div>

    <div nz-col [nzSpan]="24">
      <nz-table
        #basicTable
        [nzData]="correctionRequestList"
        nzTableLayout="fixed"
        nzShowSizeChanger
        nzBordered
        nzSize="middle"
        nzAlign="middle"
        [nzFrontPagination]="false"
        [nzTotal]="total"
        [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplate"
        [(nzPageIndex)]="page"
        (nzQueryParams)="onQueryParamsChange($event)"
        [nzScroll]="{ x: '1150px' }"
      >
        <ng-template
          #totalRowRangeTemplate
          let-range="range"
          let-total
          style="text-align: left"
        >
          <div style="text-align: left">
            Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
          </div>
        </ng-template>
        <thead>
          <tr>
            <th style="text-align: center; width: 70px;">Sl.</th>
            <th style="text-align: center" >Name of STP</th>
            <th style="text-align: center" >Application ID</th>
            <th style="text-align: center">Application Date</th>
            <th style="text-align: center">Registration Number</th>
            <th style="text-align: center">District</th>
            <th style="text-align: center">Status</th>
            <th style="text-align: center; width: 100px;" nzRight>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>
            <td style="text-align: center" nzLeft>{{ data?.stpMain?.stpName }}</td>
            <td style="text-align: center" nzLeft>
              <a [routerLink]="['/home/stp-registration/stp-application-view/', data?.stpMain?.id]"
                target="_blank" routerLinkActive="router-link-active"
                >{{ data?.stpMain?.applicationId }}
              </a>
            </td>
            <td style="text-align: center">{{ data?.stpMain?.applicationDate | date: "dd-MM-yyyy" }}</td>
            <td style="text-align: center">{{ data?.stpMain?.registrationNo }}</td>
            <td style="text-align: center">{{ data?.stpMain?.sysDistrict?.districtName }}</td>
            <td style="text-align: center">
              <span [class]="getStatusClass(data)" style="font-size: 10px">
                {{ getStatusLabel(data) }}
              </span>
            </td>
            <td style="text-align: center;" nzRight>
              <button
                class="mr-1"
                nz-button
                nzType="primary"
                title="Review Correction Request"
                [routerLink]="['/home/stp-registration/approve-stp-correction-request/' + data?.id]"
                target="_blank"
                routerLinkActive="router-link-active">
                <i nz-icon nzType="fast-forward" nzTheme="outline"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
